import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { track, EVENTS } from "@/lib/analytics";

export const useStartFlow = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (location = "cta", plan) => {
    track(EVENTS.CTA_CLICK, { location, plan });
    if (plan) {
      track(EVENTS.PLAN_SELECTED, { plan });
      sessionStorage.setItem("rp_plan", plan);
    }
    if (!user) {
      navigate("/signup");
    } else if (!user.paid) {
      navigate("/checkout");
    } else if (!user.onboarding_complete) {
      navigate("/onboarding");
    } else {
      navigate("/dashboard");
    }
  };
};
